// InstaWorthy - AI Profile Pic Generator Configuration

// Production configuration
const prod = {
    API_URL: "https://instaworthy-api.run.app/",
    stripePublicKey: 'pk_live_...', // TODO: Add production Stripe key
    firebaseApiKey: "AIzaSyB_iUQx65N_2QyeZb_GHkpCxwYP2heFz_0",
    firebaseAuthDomain: "instaworthy-6596d.firebaseapp.com",
    firebaseProjectId: "instaworthy-6596d",
    firebaseStorageBucket: "instaworthy-6596d.firebasestorage.app",
    firebaseMessagingSenderId: "440615038828",
    firebaseAppId: "1:440615038828:web:3d97bee319e7bc261d0d49",
    firebaseMeasurementId: "G-ELLPLXT5Q0",
    
    // AI service configurations
    falApiKey: "...", // TODO: Add Fal.ai API key
    runpodApiKey: "...", // TODO: Add RunPod API key
    
    // Token pricing packages
    tokenPricing: {
        starter: { price: 5, tokens: 20, priceId: 'price_starter' },
        popular: { price: 10, tokens: 50, priceId: 'price_popular' },
        pro: { price: 20, tokens: 120, priceId: 'price_pro' }
    },
    
    // App configuration
    maxSelfies: 10,
    minSelfies: 5,
    supportedImageTypes: ['image/jpeg', 'image/png', 'image/heic'],
    maxImageSize: 10 * 1024 * 1024, // 10MB
    
    // Training configuration
    trainingTimeEstimate: "15-20 minutes",
    generationTimeEstimate: "30-60 seconds",
    
    // Default user object
    emptyUserObject: {
        email: "",
        name: "",
        tokens: 10, // Free starter tokens
        trainingStatus: 'none', // none, uploading, training, complete, failed
        loraModelId: null,
        demographics: {
            gender: null,
            ethnicity: null,
            ageRange: null
        },
        createdAt: null,
        lastLoginAt: null,
        generationsCount: 0,
        onboardingComplete: false
    },
    
    // Photo guidelines for users
    photoGuidelines: {
        required: [
            "Clear, well-lit photos of your face",
            "Various angles (front, side profiles)",
            "Different expressions (smiling, neutral, serious)",
            "Different backgrounds and lighting",
            "Close-up shots showing facial details"
        ],
        recommended: [
            "High resolution images (1024px or larger)",
            "Good lighting (natural light preferred)",
            "Minimal makeup for best AI training",
            "Include some full-face shots",
            "Variety in poses and expressions"
        ],
        avoid: [
            "Blurry or low-quality images",
            "Heavy filters or editing",
            "Sunglasses or face coverings",
            "Multiple people in the photo",
            "Extreme lighting or shadows"
        ]
    }
};

// Development configuration
const dev = {
    API_URL: "http://localhost:8080",
    stripePublicKey: 'pk_test_...', // TODO: Add test Stripe key
    firebaseApiKey: "AIzaSyB_iUQx65N_2QyeZb_GHkpCxwYP2heFz_0",
    firebaseAuthDomain: "instaworthy-6596d.firebaseapp.com",
    firebaseProjectId: "instaworthy-6596d",
    firebaseStorageBucket: "instaworthy-6596d.firebasestorage.app",
    firebaseMessagingSenderId: "440615038828",
    firebaseAppId: "1:440615038828:web:3d97bee319e7bc261d0d49",
    firebaseMeasurementId: "G-ELLPLXT5Q0",
    
    // AI service configurations (same as prod for now)
    falApiKey: "...",
    runpodApiKey: "...",
    
    // Same configuration as prod for development
    tokenPricing: prod.tokenPricing,
    maxSelfies: prod.maxSelfies,
    minSelfies: prod.minSelfies,
    supportedImageTypes: prod.supportedImageTypes,
    maxImageSize: prod.maxImageSize,
    trainingTimeEstimate: prod.trainingTimeEstimate,
    generationTimeEstimate: prod.generationTimeEstimate,
    emptyUserObject: prod.emptyUserObject,
    photoGuidelines: prod.photoGuidelines
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;